import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function GermanyLanguage() {
    return (
        <Box sx={{ padding: "2rem", background: "#f9fafb", maxWidth: "900px", margin: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: "700", color: "#09122C", mb: 2 }}>
                🇩🇪 German & English Programs – Germany Migration & Study Support
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, color: "#374151", lineHeight: 1.7 }}>
                Our German and English programs are built for people relocating to Germany for work, education, or long-term settlement. From integration courses to professional fluency, Crystal Career Centre prepares you for success in Europe’s largest economy.
            </Typography>

            <ul style={{ lineHeight: "1.8", color: "#374151" }}>
                <li>German for residence permit & job interviews (A1–C1)</li>
                <li>German for nursing, manufacturing & IT professionals</li>
                <li>IELTS/TOEFL prep for university admissions</li>
                <li>CEFR-aligned curriculum with certified instructors</li>
            </ul>

            <Button
                variant="contained"
                href="/country/germany"
                sx={{
                    mt: 3,
                    backgroundColor: "#065f46",
                    "&:hover": { backgroundColor: "#09122C" }
                }}
            >
                View Germany Language Programs
            </Button>
        </Box>
    );
}
